import { BrandFeatureConfig, CLIViews } from 'typings/brands'

const features: BrandFeatureConfig = {
  allowProx: false,
  extendedBuyerManagement: false,
  getCLIView() {
    // Display CLI Automation for P66 plcc
    return CLIViews.LEGACY_CLI
  },
  cardActivation: false
}

export default features
